import styled from 'styled-components'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import { titleCss, h4Css } from 'app/sofia/components/Structure/Title'
import { cmsSidebarNavCss } from '../../../../components/Styled'

export const CmsContentWrap = styled.div`
  .section {
    ${sectionCss}
  }

  .container {
    ${containerCss}
  }

  .content {
    display: flex;
    align-items: flex-start;

    .sidebar {
      ${cmsSidebarNavCss}
    }
  }

  .title {
    ${titleCss}
    font-family: ${props => props.theme.font.alt.family};
  }

  h4 {
    ${h4Css}
    font-family: ${props => props.theme.font.alt.family};
  }

  p {
    margin: 0 0 20px;
    color: ${props => props.theme.palette.general.textColor};

    & + h4 {
      margin-top: 40px;
    }
  }
`
